<template>
  <content-editor
    :fields="fields"
    :publication="true"
    permission="press"
    endpoint="press"
    @update="updateState"
    module="press"
    previewModule="pers"
    :selectTags="false"
    :selectCategories="false"
    />
</template>

<script>
import ContentEditor from '@/components/editor/content_blocks/ContentEditor.vue';
import ContentDetail from '@/mixins/contentEditor/Detail';

export default {
  mixins: [ContentDetail],
  data() {
    return {
      module: 'press',
      fields: [
        {
          name: 'notes',
          required: false,
        },
        {
          name: 'title',
          required: true,
        },
        {
          name: 'projects',
          required: false,
        },
        {
          name: 'url',
          required: true,
        },
        {
          name: 'status',
          required: true,
        },
        {
          name: 'recap',
          required: true,
        },
        {
          name: 'image',
          required: true,
        },
      ],
    };
  },
  components: {
    ContentEditor,
  },
};
</script>
